import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { IoSearch } from "react-icons/io5";
import { Spacing, Colors } from "_styles";
import { EmployeeInformationColumnWidthRaw, TimelineColumnWidthRaw } from '_utils/timeline-constants';

const SearchBar = (props) => {

  const usedTheme = useSelector(selectUsedTheme);

  const minWidth = '200px';

  const [targetWidth, setTargetWidth] = useState(minWidth);

  useEffect(() => {
    if (props.employee) setTargetWidth(150);
    else if (props.transaction) setTargetWidth(200);
    else setTargetWidth(minWidth);
  }, [props.employee, props.transaction, minWidth]);


  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: Spacing.SCALE_38,
        padding: `0 ${Spacing.SCALE_8}px`,
        border: `1px solid ${usedTheme.BORDER_COLOR || "#ccc"}`,
        borderRadius: 6,
        background: props.timeline ? usedTheme.BACKGROUND_COLOR : "#fff",
        minWidth: targetWidth,
        maxWidth: targetWidth,
        ...props.style,
      }}
    >

      {/* icon */}
      <IoSearch size={18} color={usedTheme.TEXT_COLOR || Colors.GRAY_DARK} />

      {/* input */}
      <input
        type="search"
        placeholder={props.placeholder}
        value={props.value ?? ""}
        onChange={props.onChange}
        maxLength={props.maxLength}
        style={{
          flex: 1,
          marginLeft: Spacing.SCALE_6,
          background: "transparent",
          border: "none",
          outline: "none",
          color: props.timeline ? usedTheme.TEXT_COLOR : "#000",
          fontSize: 14,
        }}
      />
    </div>
  );
};

export default SearchBar;